<template>
	<v-dialog v-model="is_auto_sync_dialog_three_open" width="550" persistent>
        <v-card class="secure-modal proceed-modal csv-file-modal">
            <v-card-title style="width:926px !important;">
            	<v-card-title class="text-h5">
            		<v-card-actions class="close-icon">
					<v-btn color="primary" text @click="closeDialogThird()">
					   <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
					   </v-btn>
				   </v-card-actions>
            	</v-card-title>	 
            </v-card-title>
          <form ref="form" id="auto_sync_form" @submit.prevent lazy-validation>
            <v-card-text >
              <v-container>
                <v-row >
	                <v-col cols="12" sm="12" md="12">
	                    <label>Statement Type</label>
	                    <v-select
	                      ref="statement_type"
	                      name="statement_type" 
	                      v-model="statement_type"
	                      :items="statement_type_itmes"
	                      item-value="type"
	                      item-text="name"
	                      placeholder="Select Statement Type"
	                      @change  = "setLabel($event)"
	                    ></v-select>
	                    <p style="color:red;">{{statement_type_error_text}}</p>
	                </v-col>

	                <v-col cols="12" sm="12" md="12">
	                    <label>Select Member (Select member for whom you want to sync email)</label>
	                    <v-select
	                      ref="member"
	                      name="member" 
	                      v-model="member"
	                      :items="member_items"
	                      item-value="id"
	                      item-text="name"
	                      placeholder="Select Member"
	                      @change = "checkConsent($event)"
	                    ></v-select>
	                    <p style="color:red;">{{member_error_text}}</p>
                      
                        <div v-if="is_track_pan">
                        	<p style="color:blue">{{infoLabel}}</p>
                        	<v-text-field
							  name="password"
							  v-model="password"
							  ref="password" 
							  id = "password"
							  :placeholder="password_placholder"
							></v-text-field>
							<p style="color:red;">{{password_error_text}}</p>
                        </div>	
	                </v-col>	
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions >
              <v-spacer></v-spacer>
              <v-btn
                class="blue-border-btn"
                text
                @click="closeDialogThird()"  
              >
                Close
              </v-btn>
              <v-btn
                style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;"
                text
                @click="submitSyncStatementForm"  
              >
                Proceed
              </v-btn>
            </v-card-actions>
          </form>  
        </v-card>
	</v-dialog>
</template>	
<script>
    import { Auth } from "aws-amplify";
    import Datepicker from 'vuejs-datepicker';
    import axios from "axios";
    
    export default {
 		components: {
		  Datepicker,
		},
	  	props: ['is_auto_sync_dialog_three_open_status', 'get_auto_sync_dialog_three_data'],
	  	data: function () {
		    return { 
			  	is_auto_sync_dialog_three_open:this.is_auto_sync_dialog_three_open_status,
          delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
          statement_type_error_text:'',
          statement_type_itmes:[],
          member_error_text:'',
          member_items:[],
          main_member_detail:'',
          family_member_list:[],
          password_placholder:'Enter PAN No.',
          password_error_text:'',
          password:'',
          member:'',
          statement_type:'',
          is_track_pan:false,
          member_email:'',
          member_name:'',
          infoLabel:''
		    }
		},

		mounted (){
      this.statement_type_itmes = [];
			if(this.get_auto_sync_dialog_three_data !='retirement'){
				this.infoLabel = "We will need the PAN number to read the statements and update records";
        this.statement_type_itmes.push({'type':'nsdl', 'name':'NSDL eCAS'}, {'type':'cdsl', 'name':'CDSL eCAS'})
        this.password_placholder = 'Enter PAN No.';
			}
			else{
				this.infoLabel  = "We will need the PRAN number to read the statements and update records";
				this.is_track_pan  = true;   
        this.statement_type_itmes.push({'type':'kfintech', 'name':'Kfintech CRA'}, {'type':'protean_cra', 'name':'Protean CRA'})
        this.password_placholder = 'Enter PRAN No.';
			}
			this.appendMemberList()
		},	

		methods:{
			setLabel(e){
        if(e == 'protean_cra'){
          this.password_placholder = "Enter Password";
          this.infoLabel = "We will need password to read the document and the password is of 8 characters with first 4 letters your name in lower case and last 4 characters is your date of birth in DDMM format. In case first name is less than 4 letter, please add 9 before entering first 4 letters of your name."; 
        }
        else if(e == 'kfintech'){
        	this.password_placholder = "Enter PRAN No.";
          this.infoLabel = "We will need the password to read the document. The Password is your 12 digit  'PRAN' number.";
        }
			},
			proceedAutoTrackDialogFourth(){
        this.$emit('allowAutoSyncDialogFourth', true);        
			},

			closeDialogThree(){
				this.$emit('allowAutoSyncDialogFourth', false);        
			},

			appendMemberList(){
				this.member_items = []
				Auth.currentAuthenticatedUser({
					bypassCache: false
				}).then(user => {
				    this.main_member_detail = user.attributes;	
					this.user_name = user.attributes["custom:name"];
					this.member_items.push({'id':'0', 'name':this.user_name});
				})

				let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
				let formdata  = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
				axios.post(process.env.VUE_APP_ROOT_API + "get-family-member-list", formdata)
				.then((response) => {
		    	    this.family_member_list = response.data.data;
		            this.family_member_list.forEach(member_detail=>{
		            	this.member_items.push({id:member_detail.id, name:member_detail.name})
		            })
			  });
			},

			submitSyncStatementForm(){
				let is_error = false;
				(this.statement_type === "")?(is_error=true, this.statement_type_error_text = 'Statment type is required'):(is_error=false, this.statement_type_error_text = '');
				(this.member == '')?(is_error=true, this.member_error_text = 'Member is required'):(is_error=false, this.member_error_text = '');

				(this.is_track_pan == true && this.password == '')?(is_error=true, this.password_error_text = 'PAN is required'):(this.is_track_pan == true && this.password != '')?(is_error=false, this.password_error_text = ''):'';
				if(!is_error ){
			    	this.$emit('allowAutoSyncDialogFourth', {'status':true, 'statement_type':this.statement_type, 'member':this.member, 'password':this.password, 'member_name':this.member_name}); 
				}	
			},

			checkConsent(id){ 
				this.member_email = "";
				this.member_name  = "";
        this.password = "";
        if(id == '0'){
        	this.member_email = this.main_member_detail.email;
        	this.member_name = this.main_member_detail['custom:name'];
          if(this.main_member_detail['custom:pancard'] !=undefined){
          	if(this.get_auto_sync_dialog_three_data =='mf'){
              this.password = this.main_member_detail['custom:pancard']
          	}
          }
          else{
            this.is_track_pan = true
          }
        }
        else{
        	this.family_member_list.forEach(item=>{
          	if(item.id == id){
          		this.member_name = item.name
          		if(item.pan == 'N/A'){
          	    this.member_email = item.email;
                this.is_track_pan = true
          		}
          		else{
          			if(this.get_auto_sync_dialog_three_data =='mf'){
          			  this.password  = item.pan
          			}
          		}
          	}
          })
        }
			},

			closeDialogThird(){
			    this.$emit('allowAutoSyncDialogFourth', {'status':false}); 

			}
		}
	}	
</script>
<style scoped>
  .tex_color{
  	  color: #0144AF !import;
  }
  .menuable__content__active {
    box-shadow: 0px 2px 6px #00000026;
    padding: 20px;
    background-color: #fff;
    top: 71px !important;
}
</style>    	